import ReceiptInvoices from './ReceiptInvoices'
import ReceiptButtonGroup from 'components/receipt/invoices/ButtonGroup/ReceiptButtonGroup'
import { Modal, Button } from 'react-bootstrap'
import styles from './style.receipt.css'

class ReceiptInvoicesModal extends React.Component {
  render () {
    let {receiptInvoices} = this.props
    return (
      <div>
        <Modal show={this.props.show} bsClass='receipt-invoice-modal box-detail-modal modal' backdrop={false}>
          <Modal.Body className={styles['modal-body']}>
            <ReceiptButtonGroup
              clickResendButton={() => this.props._onClickResendButton(receiptInvoices.id)}
              invoiceDetail={this.props.receiptInvoices}
              onClickRecordPayment={this.props._onClickRecordPayment}
              onClickPrintButton={() => this.props._showReceiptInvoicePdf(receiptInvoices.id)}
              onCancelInvoice={this.props.onCancelInvoice}
            />
            <div className={`mk-col-right-box ${styles.details}`}>
              <ReceiptInvoices invoiceDetail={this.props.receiptInvoices} />
            </div>
            <Modal.Footer>
              <Button className='btn btn-primary'
                onClick={this.props.onHide}>
                Done
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      </div>

    )
  }
}

export default ReceiptInvoicesModal



// WEBPACK FOOTER //
// ./app/pages/Reports/Invoices/ReceiptInvoices/ReceiptInvoicesModal.js